import { FadersHorizontalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Detail = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FadersHorizontalIcon size={Sizes[size]} {...rest} color={fill} />;
};

Detail.displayName = 'Detail';
